import URLQuery from 'query-string-manipulator';
//
export default class APIRequest {
  constructor(method) {
    this.baseURL = null;
    this.path = '';
    this.method = method;
    this.headers = {};
    this.body = {};
    this.queryParameters = {};
    this.bodyType = 'JSON';
  }

  async exec() {
    try {
      // Build URL
      let reqURL = null;
      if (Object.keys(this.queryParameters).length > 0) reqURL = URLQuery(this.baseURL + this.path, { set: this.queryParameters });
      else reqURL = this.baseURL + this.path;
      // inject IE polyfill for fetch
      await import('whatwg-fetch');
      // Make request
      const respObj = await fetch(reqURL, this._buildRequest());
      //Build and return response
      return await this._buildResponse(respObj);
    } catch (e) {
      return { error: e, statusCode: -1 };
    }
  }
  //
  appendHeader(key, value) {
    this.headers[key] = value;
  }
  appendQueryParam(key, value) {
    this.queryParameters[key] = value;
  }
  /* private */
  _buildRequest() {
    let request = {
      method: this.method,
      redirect: 'follow',
      ...(Object.keys(this.headers).length > 0 ? { headers: this.headers } : {}),
    };
    if (this.bodyType == 'JSON' || this.bodyType == 'JSON/BLOB') {
      if (Object.keys(this.body).length > 0) request.body = JSON.stringify(this.body);
    } else if (this.bodyType == 'BINARY') {
      if (this.body) request.body = this.body;
    } else { if (this.body && this.body.length > 0) request.body = this.body; }
    return request;
  }
  async _buildResponse(respObj) {
    const contentType = respObj.headers.get('Content-Type');
    if (contentType && contentType.includes('json')) {
      return { body: await respObj.json(), statusCode: respObj.status };
    } else if (this.bodyType == 'BLOB' || this.bodyType == 'JSON/BLOB') {
      return { body: await respObj.blob(), statusCode: respObj.status };
    } else if (contentType && contentType.includes('image') || this.bodyType == 'BINARY') {
      return { body: await respObj.text(), statusCode: respObj.status };
    } return { body: await respObj.json(), statusCode: respObj.status };
  }
}
